<template>
  <div>
    <settings-layout
      v-model="configs"
      :items="configs"
      :isAdmin="isAdmin"
      :loading="serversLoading"
      :properties="properties"
      :status="status"
      :img="outputImg"
      :testLoading="testLoading"
      :imgLoading="outputImgLoading"
      @click:save="save"
      @click:test="test"
    >
      <template #actions v-if="configs.output_id">
        <b-dropdown-item @click="toDuplicate" aria-role="listitem">{{ $t('lists.duplicate') }}</b-dropdown-item>
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{ $t('lists.deleteDetail') }}</b-dropdown-item>
      </template>
    </settings-layout>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import SettingsLayout from '@/layout/SettingsLayout'

const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'Output',
  components: {
    SettingsLayout
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role,
      title: state => state.title
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  data() {
    return {
      serversLoading: false,
      testLoading: false,
      outputImgLoading: false,
      configs: {},
      properties: {},
      status: '',
      outputImg: ''
    }
  },
  created() {
    if (!this.isAdmin) {
      this.$router.push({
        name: 'outputs',
        params: {
          server_id: this.$route.params.server_id
        }
      })
    }
    if (
      this.$route.query.duplicate !== undefined ||
      this.$route.query.type !== undefined ||
      this.$route.params.output_id !== undefined
    ) {
      this.getDefaultConfig()
    } else {
      this.$router.push({
        name: 'outputs',
        params: {
          server_id: this.$route.params.server_id
        }
      })
    }
  },
  methods: {
    ...mapActions('general', ['setTitle']),
    ...mapActions('general', ['setServerName']),
    save() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/output`
      this.configs.name = this.title
      fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          output_config: this.configs
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$router.push({
            name: 'outputs',
            params: {
              server_id: this.$route.params.server_id
            }
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
      //        .finally(() => {
      //          this.$router.go()
      //        })
    },
    toDuplicate() {
      this.$router.push({
        name: 'add_output',
        query: {
          duplicate: this.$route.params.output_id
        },
        params: {
          server_id: this.$route.params.server_id
        }
      })
    },
    duplicate() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/output/duplicate`
      this.serversLoading = true
      fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          output_id: this.$route.query.duplicate
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.configs = data.config
          this.properties = data.properties
          this.setTitle(this.configs.name)
          this.setServerName(data.server_name)
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.serversLoading = false
        })
    },
    test() {
      this.getImage(this.configs)
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/output/test`
      this.testLoading = true
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          output_config: this.configs
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(status => {
          this.status = status
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.testLoading = false
        })
    },
    getDefaultConfig() {
      if (!this.serversLoading) {
        if (this.$route.name === 'add_output' && this.$route.query.duplicate != undefined) {
          return this.duplicate()
        }

        const body = {
          server_id: this.$route.params.server_id
        }
        if (this.$route.query.type !== undefined) {
          body.type = this.$route.query.type
        }
        if (this.$route.params.output_id !== undefined) {
          body.output_id = this.$route.params.output_id
        }
        const searchParams = new URLSearchParams(body)
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/output?${searchParams}`
        this.serversLoading = true
        return fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.configs = data.config
            this.properties = data.properties
            this.setTitle(this.configs.name)
            this.setServerName(data.server_name)
            if (
              this.$route.params.output_id !== undefined ||
              (this.$route.params.output_id === undefined && this.configs.output_id)
            ) {
              this.getImage(this.configs)
            }
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    getImage(output_config) {
      const body = {
        server_id: this.$route.params.server_id,
        output_config: JSON.stringify(output_config)
      }

      const searchParams = new URLSearchParams(body)
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/output/image?${searchParams}`
      this.outputImgLoading = true
      return fetch(url, {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(outputImg => {
          this.outputImg = outputImg
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.outputImgLoading = false
        })
    },
    deleteOutput() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/output/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          output_id: this.configs.output_id
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$router.push({
            name: 'outputs',
            params: {
              server_id: this.$route.params.server_id
            }
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    openDialogRemove() {
      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: this.configs.name
        })}?`,
        onConfirm: () => {
          this.serversLoading = true
          this.deleteOutput()
            .then(() => {
              this.$notify({
                message: this.$t('notification.removed', {
                  msg: this.configs.name
                }),
                type: 'success'
              })
            })
            .finally(() => {
              this.serversLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  width: 100%;
}
</style>
